
/*
 * @Descripttion: no
 * @version: 1.0.0
 * @Author: fugang
 * @Date: 2022-05-05 09:51:37
 * @LastEditors: fugang
 * @LastEditTime: 2022-05-12 15:40:50
 */

import { RouteRecordRaw } from "vue-router";
import Layout from "@/layout/Index.vue";

/** 关于我们：指导文档（/aboutusdetail）+ 通知公告（仅系统管理员） */
const ExampleRouter: Array<RouteRecordRaw> = [
  {
    path: "/aboutus",
    component: Layout,
    redirect: "noredirect",
    meta: {
      title: "aboutus",
      icon: "#icon-shiyongwendang"
    },
    children: [
      {
        path: "/aboutusdetail",
        name: "AboutusDetail",
        component: () =>
          import(
            /* webpackChunkName: "aboutus-detail" */ "@/views/aboutus/aboutus.vue"
          ),
        meta: {
          title: "guidanceDoc",
          icon: "#icon-shiyongwendang"
        }
      },
      {
        path: "/aboutus/notifications",
        component: () =>
          import(
            /* webpackChunkName: "aboutus-notice" */ "@/views/aboutus/notice-publish.vue"
          ),
        name: "NoticePublish",
        meta: {
          title: "noticePublish",
          noCache: true,
          roles: ["系统管理员"],
          icon: "#icon-shiyongwendang"
        }
      }
    ]
  }
];

export default ExampleRouter;
